<script>
    import { createEventDispatcher } from "svelte";

    import Datepicker from "svelte-calendar";

    export let value;
    export let start;
    export let end = new Date(new Date().setFullYear(2100));

    let oldValue = value;

    const dispatch = createEventDispatcher();

    const checkIfHasChanged = (value) => {
        if (oldValue !== value) dispatch("change");
        oldValue = value;
    };

    $: checkIfHasChanged(value);
</script>

<Datepicker bind:selected={value} {end} format={'#{d}/#{m}/#{Y}'} {start}>
    <slot />
</Datepicker>
